import Vue from 'vue'
/*
 * 节流函数 - 在指定时间段内仅处理一次
 * Parameters：
 * @wait Number(60ms) 延迟执行的时间间隔
 * @func Function 延迟执行的函数
 * Return：
 * Function 节流处理后的函数
 * Example：
 * let func = throttle(200, function f() {}).bind(组件this)
 */
export function throttle(wait, func) {
  let _func = func
  let _last = new Date()
  let _context = this
  let _wait = wait
  let _timer = null
  if (typeof wait === 'function') {
    _func = wait
    _wait = 60
  }

  return function(...args) {
    const now = new Date()
    const diff = now - _last
    if (_timer) {
      clearTimeout(_timer)
      _timer = null
    }
    if (diff >= _wait) {
      _func.apply(_context, args)
      _last = now
    } else {
      _timer = setTimeout(function() {
        _func.apply(_context, args)
        clearTimeout(_timer)
        _timer = null
        _last = now
      }, _wait - diff)
    }
  }
}

// let rootFontSize = 0
/*
 * 计算rem单位
 */
export function getBasicPx() {
  let rootFontSize = 16;
  // if (rootFontSize <= 0) {
    // let width = document.body.clientWidth
    // if (width <= 720) {
    //   rootFontSize = width / 25
    // } else {
    //   rootFontSize = 16
    // }
  // }
  let width = document.body.clientWidth
  if (width) {
    rootFontSize = width / 25
  }
  return rootFontSize
}

export function isWechat() {
  return navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1
}

export function isAndroid() {
  const ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
}

export function getCookie() {
  var cookie = {}
  var all = document.cookie
  if (all === '') {
    return cookie
  }
  var list = all.split('; ')
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var p = item.indexOf('=')
    var name = item.substring(0, p)
    name = decodeURIComponent(name)
    var value = item.substring(p + 1)
    value = decodeURIComponent(value)
    cookie[name] = value
  }
  return cookie
}

// 监控上报
export function errorReport(e) {
  console.error(e)
  // 因tfm升级，原有的监控上报暂时取消，待后续再添加
  // if (process.env.VUE_APP_LOCAL !== 'Q' && process.env.VUE_APP_LOCAL !== 'C') {
  //   const { getTfmClient } = require('@tujia/fe_falcon')
  //   getTfmClient('feccms.tujia.com').error(
  //     {
  //       exception: e
  //     },
  //     { path: 'webErrorLog' }
  //   )
  // }
}
//解析 query 参数的exclusiveHouse字段
export function getExclusiveHouse(exclusiveHouse) {
  if(exclusiveHouse){
    const ids = decodeURIComponent(exclusiveHouse)
    if(ids.includes(',')){
      return ids.split(',')
    }else if(ids.includes('，')){
      return ids.split('，')
    }else{
      return  [exclusiveHouse]
    }
  }else{
    return  []
  }
}

export const eventBus = new Vue()
